import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

function initialState() {
  return {
    marketExpertListByStockId: [],
    filter_list: [],
    user_details: {},
    expert_details: {},
    visible_demo_dialog: false,
    subscribed_features_list: [],
    subscribed_plan_details: {},
    publisher_plan_details: {},
    chat_plan_details: {},
    is_subscribe_plan_dialog_visible: false,
    my_account_active_state: "",
    billing_details: {},
    bank_details: {},
    active_payment_faq_menu: "SUBSCRIPTION",
    active_support_page_state: "NEW_TICKET",
    notifications_list: {
      data: [],
    },
    active_term: "shortTerm",
    market_list: [],
    stocks_live_price_list: [],
    selected_market_type: {},
    selected_store_type: {},
    bucket_details: {},
    market_ideas_sub_menu: "ALL_COMPANIES",
    active_EFS_sub_menu: "EARN_FROM_STOCKANTS",
    active_dashboard_submenu: "EXPERTS_HUB",
    active_trade_menu: "TRADE",
    selected_order_id: "",
    selected_order_type: "",
    selected_order: {},
    is_login_through_broker_dialog_visible: false,
    is_login_through_hybrid_broker_dialog_visible: false,
    market_segment: localStorage.getItem('market_type') ? localStorage.getItem('market_type') : 'equity',
    stock_id: null,
    optionEditStockDetails: "",
    dashboardActivePeriod: "1M",
    expertActivePeriod: "1M",
    tradeDialogVisible: false,
    isQRcodePopupVisible: false,
    planStatus: [],
    isPlanProcessPopup: false,
    isRiskProfileCompleted: false,
    isPaymentSuccess: false,
    is_user_login_status: true,
    showAgreementPopupStatus: false,
    unreadNotificationCount: null,
    room_id: null,
    typingEvent: {},
    lastMessageObj: {},
    sessionDetails: {},
    newChatRequestDialogVisible: false,
    newChatRequestObj: {},
    selectedUserForChat: {},
    recentUsers: []
  };
}

export default new Vuex.Store({
  // state: {
  //   marketExpertListByStockId: [],
  //   filter_list: [],
  //   user_details: {},
  //   visible_demo_dialog: false,
  //   subscribed_features_list: [],
  //   subscribed_plan_details: {},
  //   is_subscribe_plan_dialog_visible: false
  // },
  state: initialState(),

  mutations: {
    storeUnreadCount(state, payload) {
      state.unreadNotificationCount = payload;
    },

    commitUserLoginStatus(state, payload) {
      state.is_user_login_status = payload;
    },
    commitRiskProfileDialog(state, payload) {
      state.isRiskProfileCompleted = payload;
    },

    commitKycDialog(state, payload) {
      state.isPlanProcessPopup = payload;
    },

    commitQRCodePopup(state, payload) {
      state.isQRcodePopupVisible = payload;
    },

    storePlanStatus(state, payload) {
      state.planStatus = payload;
    },

    storePaymentStatus(state, payload) {
      state.isPaymentSuccess = payload;
    },

    // storeAgreementPopupStatus(state, payload) {
    //   state.showAgreementPopupStatus = payload;

    // },

    tradePopupAction(state, payload) {
      state.tradeDialogVisible = payload;
    },

    selectActivePeriod(state, payload) {
      state.dashboardActivePeriod = payload;
    },

    selectExpertActivePeriod(state, payload) {
      state.expertActivePeriod = payload;
    },

    optionEditStockData(state, payload) {
      state.optionEditStockDetails = payload;
    },

    dashboardFilterList(state, payload) {
      state.filter_list = payload;
    },
    //saves market expert list by stock id for result page filter
    saveMarketExpertList(state, payload) {
      state.marketExpertListByStockId = payload;
    },

    saveUserDetails(state, payload) {
      state.user_details = payload;
    },

    commitExpertDetails(state, payload) {
      state.expert_details = payload;
    },

    commitDialogVisibility(state, payload) {
      state.visible_demo_dialog = payload;
    },

    commitSubscribedFeatures(state, payload) {
      state.subscribed_features_list = payload;
    },

    commitSubscribedPlanDetails(state, payload) {
      state.subscribed_plan_details = payload;
    },

    commitPublisherPlanDetails(state, payload) {
      state.publisher_plan_details = payload;
    },

    commitChatPlanDetails(state, payload) {
      state.chat_plan_details = payload;
    },

    commitSubscribPlanDialogVisibility(state, payload) {
      state.is_subscribe_plan_dialog_visible = payload;
    },

    commitMyAccountActiveState(state, payload) {
      state.my_account_active_state = payload;
    },

    commitBillingDetails(state, payload) {
      state.billing_details = payload;
    },

    commitBankDetails(state, payload) {
      state.bank_details = payload;
    },

    commitActivePaymentFAQMenu(state, payload) {
      state.active_payment_faq_menu = payload;
    },

    commitSupportPageActiveState(state, payload) {
      state.active_support_page_state = payload;
    },

    commitNotificationsList(state, payload) {
      state.notifications_list = payload;
    },

    commitActiveTerm(state, payload) {
      state.active_term = payload;
    },

    commitMarketList(state, payload) {
      state.market_list = payload;
    },

    commitStocksLivePriceList(state, payload) {
      state.stocks_live_price_list = payload;
    },

    commitSelectedMarketType(state, payload) {
      state.selected_market_type = payload;
    },

    commitSelectedStoreType(state, payload) {
      state.selected_store_type = payload;
    },

    commitBucketDetails(state, payload) {
      state.bucket_details = payload;
    },

    commitMarketIdeaSubMenues(state, payload) {
      state.market_ideas_sub_menu = payload;
    },

    commitEFSSubMenues(state, payload) {
      state.active_EFS_sub_menu = payload;
    },

    commitDashboardActiveSubMenue(state, payload) {
      state.active_dashboard_submenu = payload;
    },

    commitOrderId(state, payload) {
      state.selected_order_id = payload;
    },

    commitTradeMenu(state, payload) {
      state.active_trade_menu = payload;
    },

    commitSelectedOrder(state, payload) {
      state.selected_order = payload;
    },

    commitSelectedOrderType(state, payload) {
      state.selected_order_type = payload;
    },

    commitBrokerLoginDialogVisibility(state, payload) {
      state.is_login_through_broker_dialog_visible = payload;
    },

    commitHybridBrokerLoginDialogVisibility(state, payload) {
      state.is_login_through_hybrid_broker_dialog_visible = payload;
    },

    commitMarketSegment(state, payload) {
      state.market_segment = payload;
    },

    commitStockIdForSentimentCard(state, payload) {
      state.stock_id = payload;
    },

    commitRoomId(state, paylaod) {
      state.room_id = paylaod;
    },

    commitUserTypingEvent(state, paylaod){
      state.typingEvent = paylaod;
    },

    commitLastMessage(state, payload){
      state.lastMessageObj = payload;
    },

    commitUserChatSessionDetails(state, payload){
      state.sessionDetails = payload;
    },

    commitNewChatRequestDialogState(state, payload){
      state.newChatRequestDialogVisible = payload;
    },

    commitNewChatRequestObj(state, payload){
      state.newChatRequestObj = payload;
    },

    commitSelectedUserForChatObj(state, payload){
      state.selectedUserForChat = payload;
    },

    commitRecentUsers(state, payload){
      state.recentUsers = payload;
    },

    // to reset all state to it's initial state
    resetAllState(state) {
      // acquire initial state
      const s = initialState();
      Object.keys(s).forEach((key) => {
        state[key] = s[key];
      });
    },
  },
  actions: {},
});
